import paginacaoListagem from '@/core/store/default/paginacaoListagem'

export default {
	paginacao: paginacaoListagem([], 25),
	filtro: {
		codigoOuDescricaoItem: {
			default: null,
			label: 'Pesquisa',
			value: null,
		},
		idAta: null,
	},
	anexos: {
		paginacao: paginacaoListagem([], 25),
		datasource: [],
		totalPaginas: 0,
		totalItens: 0,
	},
	idSolicitacaoAdesao: {
		default: null,
		label: 'idSolicitacaoAdesao',
		value: null,
	},
	estadoAnteriorForm: null,
	justificativa: '',
	formIsValid: false,
	datasource: [],
	totalPaginas: 0,
	totalItens: 0,
}
